export enum CrossPromoStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DISMISSED = 'DISMISSED',
    SWITCHED = 'SWITCHED',
}

export enum BotOptStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DISMISSED = 'DISMISSED',
    SUBSCRIBED = 'SUBSCRIBED',
}

export interface IUserState {
    userId: string;
    username: string;
    userAvatar: string;

    subscribeBot: BotOptStatus;
    crossPromo: CrossPromoStatus;

    /**
     * Total level attempts during this session.
     * Used to determine when to show the cross promo link.
     */
    levelAttempts: number;
}
